import { VariantProps } from 'class-variance-authority'

import { buttonVariants } from '@frame/ui-primitives/button'

import { DataAttribute } from '@frame/types'

import { VerifierRequirements } from './api/client-session/types'
import { IncomeType } from './types'

export const TW_EMAIL = 'support@truework.com'
export const TW_PHONE = '1-833-878-3967'

export const INCOME_CARD_CONFIG = {
  [IncomeType.EMPLOYED]: {
    title: 'Employed income',
    desc: "Select this if you're working for an employer and receive paystubs.",
    button: {
      text: 'Add employer income',
      variant: 'primary' as VariantProps<typeof buttonVariants>['intent'],
    },
    dataCy: DataAttribute.BTN_ADD_EMPLOYED_INCOME,
  },
  [IncomeType.OTHER]: {
    title: 'Other income',
    desc: 'Select this if your income comes from self-employed, disabled, retired, guarantor, child support, alimony, or any other sources.',
    button: {
      text: 'Add other income',
      variant: 'secondary' as VariantProps<typeof buttonVariants>['intent'],
    },
    dataCy: DataAttribute.BTN_ADD_OTHER_INCOME,
  },
}

export const NO_ARGYLE_ITEM_ID_FOUND_IDENTIFIER = 'unknown'

export const verifierRequirementsMapping: Record<VerifierRequirements, string> = {
  [VerifierRequirements.EMPLOYMENT_2_YEARS]: 'the past 2 years of income to verify',
  [VerifierRequirements.EMPLOYMENT_3_YEARS]: 'the past 3 years of income to verify',
  [VerifierRequirements.INCOME_CURRENT]: 'your current source(s) of income',
}

export const addEmploymentMapping: Record<VerifierRequirements, string> = {
  [VerifierRequirements.EMPLOYMENT_2_YEARS]: 'the past 2 years of income',
  [VerifierRequirements.EMPLOYMENT_3_YEARS]: 'the past 3 years of income',
  [VerifierRequirements.INCOME_CURRENT]: 'your current source(s) of income',
}
